import { IBasicAutomation } from 'modules/settings/models';
import API from 'services/api';

export const getBasicAutomation = (): Promise<IBasicAutomation> =>
  API.get('/api/basic-automation/triggers').then(response => response?.data);
